import React from 'react';
import { useLoader } from '@react-three/fiber';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader';

export default function SkullScene({ targetPosition }) {
  // Load the GLB model unconditionally
  const gltf = useLoader(GLTFLoader, '/assets/Skull_2a.glb');

  // Check if the model loaded successfully
  if (!gltf || !gltf.scene) {
    console.error('Error: GLTF model could not be loaded. Ensure the file path is correct and the server serves the file.');
    return (
      <mesh>
        <boxGeometry args={[1, 1, 1]} />
        <meshBasicMaterial color="red" />
      </mesh>
    );
  }

  return (
    <>
      <primitive
        object={gltf.scene}
        scale={[0.2, 0.2, 0.2]}
        position={targetPosition || [0, 0, 0]}
        rotation={[0, 0, 0]}
      />
      <ambientLight intensity={0.5} />
      <directionalLight position={[5, 5, 5]} />
    </>
  );
}
